@if (appMode() !== 'legacy') {
  <div class="not-found">
    <ftr-illustration [illustration]="illustration.PageNotFound" />
    <h1 class="pageTitle">The page you’re looking<br />for can’t be found.</h1>
    <ftr-tertiary-button text="Go to Home" iconLeft="HomeOutline" theme="primary" (onClick)="goToHome()" />
  </div>
} @else {
  <ftr-page>
    <article class="not-found-legacy">
      <div class="card card--borderless">
        <div class="not-found-legacy__thumb">
          <ftr-illustration [illustration]="illustration.FourOhFour" />
        </div>
        <p class="not-found-legacy__message1">
          Sorry, the page you are looking for does not exist or is no longer available.
        </p>
        <p class="not-found-legacy__message2">Perhaps you were looking for one of the following:</p>
        <ul class="not-found-legacy__menu">
          <li class="not-found-legacy__menu__item"><a routerLink="/">Home</a></li>
          <li class="not-found-legacy__menu__item"><a routerLink="/orders">My Orders</a></li>
          <li class="not-found-legacy__menu__item"><a routerLink="/account">Account Details</a></li>
        </ul>
      </div>
    </article>
  </ftr-page>
}
